/**
 * `device_type` values for VeSync / ESP-style outlet controllers (Mongo + DeviceController).
 * New models: add the string built in DeviceController `search_for_new_outlets` (see app.py:
 * `"Outlet " + device_data['Model'] + " 2"`).
 */
export const OUTLET_DEVICE_TYPES = ['Outlet ESO15-TB 2'] as const

export function isOutletDeviceType(deviceType: string | undefined): boolean {
    if (!deviceType) return false
    return (OUTLET_DEVICE_TYPES as readonly string[]).includes(deviceType)
}
